import * as React from 'react';
import ReactDOM from 'react-dom';
import { Checkbox } from '@material-ui/core';
import "src/js/common/polyfill/closest";

interface IProps {
	parent: HTMLElement,
}

export default function SearchDialogCheckbox(props: IProps) {
	const [checked, setChecked] = React.useState(false);

	const row = React.useRef<HTMLTableRowElement>();

	React.useEffect(() => {
		let observer = new MutationObserver(mutationCallback);
		
		row.current = props.parent.closest("tr");
		observer.observe(row.current, { attributes: true });
		
		return () => {
			observer.disconnect();
		}
	}, []);

	function mutationCallback(mutationsList ) {
		for (let mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				let currentClassState = mutation.target.classList.contains('row_selected') as boolean;

				setChecked(currentClassState);
			}
		}
	}

	function selectRow(row: HTMLElement) {
		row.classList.add('row_selected');
	}

	function unselectRow(row: HTMLElement) {
		row.classList.remove('row_selected');
	}

	function handleChange(v: boolean) {
		if (v)
			selectRow(row.current);
		else
			unselectRow(row.current);
	}

	return <Checkbox
		color="primary"
		checked={checked}
		onChange={(e) => handleChange(e.target.checked)}
	/>		
}